module.exports = __WEBPACK_EXTERNAL_MODULE_socket_io_client__;